/*
 *  Author: DL
 *  Date: 2020-12-10 15:19:45
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 18:27:23
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import { getQueryString } from 'utils/tools';
import settingConfig from 'config/setting';

const { gps, bluetooth, simulation, outdoorGroupID } = settingConfig;

let timer = 0;

function Subject() {
    this.observers = [];
}

Subject.prototype.add = function(observer) {
    this.observers.push(observer);
};

Subject.prototype.remove = function(observer) {
    const index = this.observers.indexOf(observer);
    this.observers.split(index, 1);
};

Subject.prototype.notice = function(coordinate) {
    this.observers.forEach(item => {
        const fn = item ? item : null;

        if (fn) {
            const { type } = coordinate;
            if (type === 'bluetooth') {
                // if (timer2 < 3) {
                // timer2++;
                // console.log(`当前获取蓝牙位置,命中${timer2}次`, coordinate);
                // } else {
                timer = 0;
                fn(coordinate);

                // }
                // console.log('蓝牙', coordinate.x, coordinate.y);
            } else if (type === 'GPS') {
                if (timer < 5) {
                    timer++;
                    // console.log(`当前获取GPS位置,命中${timer}次`);
                } else {
                    fn(coordinate);
                    // console.log('gps', coordinate.x, coordinate.y);
                }
                // timer2 = 0;
            } else {
                fn(coordinate);
            }
        }
    });
};

let gpsSubject = new Subject();

// GPS
(function() {
    if (!gps) return;

    let timer = null;

    const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
    };

    function lonLat2WebMercator(GPS) {
        var earthRad = 6378137.0;
        var x = ((GPS.longitude * Math.PI) / 180) * earthRad;
        var a = (GPS.latitude * Math.PI) / 180;
        var y = (earthRad / 2) * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));

        return {
            x: parseFloat(x),
            y: parseFloat(y),
        };
    }

    function error(e) {
        if (timer) {
            navigator.geolocation.clearWatch(timer);
        }

        switch (e.code) {
            case e.PERMISSION_DENIED:
                console.log('定位失败,用户拒绝请求地理定位');
                //alert("定位失败,用户拒绝请求地理定位");
                break;
            case e.POSITION_UNAVAILABLE:
                console.log('定位失败,位置信息是不可用');
                //alert("定位失败,位置信息是不可用");
                break;
            case e.TIMEOUT:
                console.log('定位失败,请求获取用户位置超时');
                //alert("定位失败,请求获取用户位置超时");
                break;
            case e.UNKNOWN_ERROR:
                console.log('定位失败,定位系统失效');
                //alert("定位失败,定位系统失效");
                break;
            default:
                console.log('未知错误');
        }
    }

    function success(position) {
        if (!position) return;

        const longitude = position.coords.longitude; //经度
        const latitude = position.coords.latitude; //纬度
        const { x, y } = lonLat2WebMercator({ longitude, latitude });

        gpsSubject.notice({ FID: '', x, y, groupID: outdoorGroupID, name: '我的位置', floor: '', type: 'GPS' });
    }

    timer = window.navigator.geolocation.watchPosition(success, error, options);
})();

// 蓝牙
(function() {
    if (!bluetooth) return;

    const type = 'getpos';
    const mapId = getQueryString('mapId');
    const openId = getQueryString('openId');

    if (!mapId || !openId) return;

    let timer = null;

    const ws = new WebSocket('wss://indoor.yunweizhi.net:2020');

    const data = JSON.stringify({ type, mapId, openId });

    ws.onopen = event => {
        timer = setInterval(() => {
            ws.send(data, event);
        }, 1000);
    };

    ws.onmessage = event => {
        const { code, x, y, floorId: groupID } = JSON.parse(event.data);

        if (code === 0) {
            gpsSubject.notice({ FID: '', x, y, groupID, name: '我的位置', floor: '', type: 'bluetooth' });
        } else {
            // console.log({ code });
        }
    };

    ws.onerror = event => {
        clearInterval(timer);
        console.log('连接失败', event);
    };

    ws.onclose = event => {
        clearInterval(timer);
        console.log('服务关闭', event);
    };
})();

// 模拟
(function() {
    if (!simulation) return;

    let defaultCoord = { FID: '', x: 13042745, y: 2720702.5, groupID: 1, name: '我的位置', floor: '', type: 'simulation' };

    setInterval(() => {
        const x = parseFloat(Math.random().toFixed(9));
        const y = parseFloat(Math.random().toFixed(9));
        const operatorX = Math.trunc(Math.random() * 11) % 2 === 0 ? x : -x;
        const operatorY = Math.trunc(Math.random() * 11) % 2 === 0 ? y : -y;
        const groupID = 1;

        defaultCoord.x += operatorX;
        defaultCoord.y += operatorY;
        defaultCoord.groupID = groupID;

        gpsSubject.notice({ ...defaultCoord });
    }, 1000);
})();

export default function location(callback) {
    gpsSubject.add(callback);
}
